import type { FaireProductEntity } from "../../entity_types/product";

export const p_7lr5gbb6: FaireProductEntity = {
  token: "p_7lr5gbb6",
  type: "product",
  name: "I Love you This Much Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/e9020a4bd80aba31aacbaf702f79dd13cb100742def9d529117fdad45a0b045b.png",
  galleryImageUrls: [
    "https://cdn.faire.com/res/hszgttpjt/image/upload/37923248bb0ce1f1f75b83bb554dc43eb2d7fb4d2d02ba5de85c2ec9064ee7a2/1528359883.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:35.978Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
